<template>
    <div class="evaluationProject">
        <leftnav class="fl" :mkcode="yj_mkcode" :itemcode="yj_itemcode" :refreeshMeunNum="refreeshMeunNum" docutitle="评项目"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <div class="index_left_centerpage">
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
                        <span :class="currentTab == item.value ? 'current title' : 'title'" v-for="(item) in tabList"
                         v-show="currentTab == item.value && currentTab!=2" @click="tabClick(item)" :key="'tabList'+item.value">{{ item.text }} <em>({{total}})</em></span>
                        <span v-show="currentTab == 2" :class="navValue == 0 ? 'current title' : 'title'" @click="currentTab = 2;navValue = '';ajaxsearchcompany(1);">全部项目</span>
                        <span v-show="currentTab == 2" :class="navValue == item.value ? 'current title' : 'title'" v-for="(item) in navList"
                         @click="navclick(item)" :key="'nav'+item.value">{{ item.text }} 
                        </span>
                    </div>
                </div>

                <div class="enterprise_list_box whitebox">
                    <div class="enterparise_guide oh" style="width: 95%; ">
                        <p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
                    </div>
                    <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
                        <tr>
                            <th>项目名称</th>
                            <th>企业名称</th>
                            <th>产业类型</th>
                            <th>评估状态</th>
                            <th>项目类型</th>
                            <th>项目状态</th>
                            <th>投资额(亿元)</th>
                            <th>年产值(亿元)</th>
                            <th v-show="currentTab != 17">评估</th>
                            <th style="width:120px" v-show="currentTab == 17">自动评估状态</th>
                            <th v-show="currentTab == 17 || currentTab == 2">操作</th>
                        </tr>
                        <tr v-for="item in enterpristlist" :key="item.stockcode">
                            <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">  {{ item.project || '-' }}</td>
                            <td @click="detailrouterto('/workbenchEnterpriseDetails', item.id)" class="title">{{ item.customerName || '-' }}</td>
                            <td>{{ item.smallClassText || '-' }}</td>
                            <td>{{ item.assessmentText  || '未评估' }}</td>
                            <td>{{ item.projectTypeText || '-'  }}</td>
                            <td>{{ item.statusText || '-'  }}</td>
                            <td>{{ item.amount || '-'  }}</td>
                            <td>{{ item.outputValue || '-'  }}</td>
                            <td v-show="currentTab == 1&&currentTab != 17" > 
                                <span class="cur-pointer bluefont display-block mb-1" @click="initiatePopup(item,'initiate')">发起人工评估> </span>
                                <span class="cur-pointer bluefont" @click="initiatePopup(item,'completeness')">发起智能评估 > </span>
                            </td>
                            <td v-show="currentTab == 2&&currentTab != 17" class="cur-pointer bluefont" @click="initiatePopup(item,'result')"> 查看>
                            </td>
                             <td class="cur-pointer bluefont" v-show="currentTab == 17" @click="initiatePopup(item,'result')"> 自动评估状态 ></td>
                             <td class="cur-pointer bluefont" v-show="currentTab == 17 || currentTab == 2" @click="reAssessment(item)"> 重新评估 ></td>
                        </tr>
                    </table>
                </div>
                <div class="centerpage1 company_pagelist" v-show="totalPage > 1">
                    <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                        v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
                </div>
                <el-dialog class="localChain" custom-class="initiate_box_dialog" :title="dialogTitle" center
                    :visible.sync="isInitiate" top="25vh" @close="closeDialog(1)">
                    <div class="mb-3">
                        <el-steps :active="aiEvaStep" finish-status="success" align-center>
                            <el-step v-for="(item,i) in aiEvaStepList " :key="i" :title="item.label"></el-step>
                        </el-steps>
                    </div>
                    <div class="initiate_box" v-show="ispretentiousness">
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>其他说明：</el-col>
                            <el-col :span="20">
                                <el-input type="textarea" :rows="4" placeholder="请输入内容"
                                    v-model="requirement"></el-input>
                            </el-col>
                        </el-row>
                    </div>
                    
                    <div class="initiate_box" v-show="currentTab ==1 && !ispretentiousness">
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>项目名称：</el-col>
                            <el-col :span="18">{{ temdialogData.project }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>企业名称：</el-col>
                            <el-col :span="18">{{ temdialogData.company || temdialogData.companyName || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>项目状态：</el-col>
                            <el-col :span="18">{{ temdialogData.statusText || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>投资方名称：</el-col>
                            <el-col :span="18">{{ temdialogData.investor || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>产业类型：</el-col>
                            <el-col :span="18">{{ temdialogData.bigClassText || '-' }}-{{ temdialogData.smallClassText || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>投资额（亿元）</el-col>
                            <el-col :span="18">{{ temdialogData.amount || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>年产值（亿元）</el-col>
                            <el-col :span="18">{{ temdialogData.outputValue || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="24" class="initiate_title"><em class="redfont">* </em>项目附件：</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"> </el-col>
                            <el-col :span="18">
                                <p v-for="(item, i) in temdialogData.fileList" class="cur-pointer font-14 mb-1 basefont"
                                    :key="i" @click="downloadFile(item.url)">{{ item.title }} ></p>
                            </el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>项目简介：</el-col>
                            <el-col :span="18">{{ temdialogData.summary || '-' }}</el-col>
                        </el-row>
                        
                    </div>
                    <div class="initiate_box" v-show="currentTab ==2 "> 
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title">{{ evaEssessmentType == 1 ? '企业名称' : '项目名称' }}：</el-col>
                            <el-col :span="18">{{ temdialogData.company || temdialogData.companyName || temdialogData.title || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1" v-show="evaEssessmentType == 1">
                            <el-col :span="6" class="initiate_title">评估需求：</el-col>
                            <el-col :span="18">{{ temdialogData.content || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title">评估状态</el-col>
                            <el-col :span="18">{{ temdialogData.statusText || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title">项目类型：</el-col>
                            <el-col :span="18">{{ temdialogData.projectTypeText || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title">评估结果：</el-col>
                            <el-col :span="18" v-show="evaEssessmentType == 1"><div v-html="temdialogData.replyContent || '-' "></div></el-col>
                            <el-col :span="18" v-show="evaEssessmentType == 2"><div v-if="temdialogData.content" class="pre-wrap-text" v-html="convertMarkdown(temdialogData.content)"></div></el-col>
                            <!-- <el-col :span="18" v-show="evaEssessmentType == 2"><vue-markdown :source="temdialogData.content" /></el-col> -->
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title">评估结果附件：</el-col>
                            <el-col :span="18" ><span @click="downloadFile(temdialogData.replyFile)" class="cur-pointer basefont">{{ temdialogData.replyFile || temdialogData.file ||'-' }} </span></el-col>
                            <!-- <el-col :span="18" v-show=" evaEssessmentType == 2"><span @click="downloadReplyFile()" class="cur-pointer basefont">{{ temdialogData.replyFile || temdialogData.file ||'-' }} </span></el-col> -->
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title">评估时间：</el-col>
                            <el-col :span="18">{{temdialogData.replyTime || temdialogData.updateTime || '-'}}</el-col>
                        </el-row>
                    </div>
                    <span slot="footer" class="dialog-footer" v-show="currentTab == 1">
                        <el-button @click="closeDialog(1)">取 消</el-button>
                        <el-button type="primary" @click="handProject" v-show="!ispretentiousness">提 交</el-button>
                        <el-button type="primary" :loading="submitLoading" @click="submitInitiate(1)" v-show="ispretentiousness">确 认</el-button>
                    </span>
                </el-dialog>
                <el-dialog class="assessmentProjectHtmlDom" custom-class="initiate_box_dialog" title="智能评估报告" center
                    :visible.sync="showProjectHtml" top="" @close="closeDialog(2)">
                    <div class="initiate_box" v-show="aiEvaStep == 1 "  >
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>项目名称：</el-col>
                            <el-col :span="18">{{ temdialogData.project }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>企业名称：</el-col>
                            <el-col :span="18">{{ temdialogData.companyName || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>项目状态：</el-col>
                            <el-col :span="18">{{ temdialogData.statusText || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>投资方名称：</el-col>
                            <el-col :span="18">{{ temdialogData.investor || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>产业类型：</el-col>
                            <el-col :span="18">{{ temdialogData.bigClassText || '-' }}-{{ temdialogData.smallClassText || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>投资额（亿元）</el-col>
                            <el-col :span="18">{{ temdialogData.amount || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>年产值（亿元）</el-col>
                            <el-col :span="18">{{ temdialogData.outputValue || '-' }}</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="24" class="initiate_title"><em class="redfont">* </em>项目附件：</el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"> </el-col>
                            <el-col :span="18">
                                <p v-for="(item, i) in temdialogData.fileList" class="cur-pointer font-14 mb-1 basefont"
                                    :key="i" @click="downloadFile(item.url)">{{ item.title }} ></p>
                            </el-col>
                        </el-row>
                        <el-row class="mb-1">
                            <el-col :span="6" class="initiate_title"><em class="redfont">* </em>项目简介：</el-col>
                            <el-col :span="18">{{ temdialogData.summary || '-' }}</el-col>
                        </el-row>
                        
                    </div>
                    <div v-loading="completenesLoading" >
                        <div class="pre-wrap-text" v-show="!isProjectHtml && aiEvaStep == 2" v-html="completenessData"></div>
                        <div class="pre-wrap-text" v-show="isProjectHtml && aiEvaStep == 3" v-html="assessmentProjectHtml"></div>
                    </div>
                    
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="closeDialog(2)">取 消</el-button>
                        <el-button type="primary" :loading="submitLoading" @click="submitInitiate(2)" v-show="aiEvaStep == 1">进行项目完整性评估</el-button>
                        <el-button type="primary" :loading="submitLoading" @click="submitInitiate(3)" v-show="aiEvaStep == 2">进行大模型评估</el-button>
                    </span>
                </el-dialog>
            </div>
        </div>

    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
       name: 'evaluationProject',

    data() {
        return {
            currentTab: '1',
            userdata: {},
            tabList: [
                { value: '1', text: '待评项目', num: 0 ,itemcode:'A-dpxm'},
                { value: '17', text: '评估中项目', num: 0 ,itemcode:'A-pgzxm'},
                // { value: '0', text: '评估中', },
                { value: '2', text: '已评项目', num: 0 ,itemcode:'A-ypxm'},
            ],
            navList: [
                { value: '1', text: 'A类项目', },
                { value: '2', text: 'B类项目',},
                { value: '3', text: 'C类项目',},
            ],
            navValue: '',
            yj_mkcode: 'A',
            yj_itemcode: 'pxm',
            enterpristlist: [],
            temdialogData: {},
            requirement: '',
            isInitiate: false,
            page: 1, //显示的是哪一页
            haspage: true, //是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 0, //记录总数
            totalPage: 1,
            maxPage: 10, //最大页数 
            dialogTitle: '提交评估需求',
            refreeshMeunNum: 1,//用来数据改变的时候刷新菜单上的数字
            ispretentiousness: false,//是否提交确认评估
            assessmentProjectHtml: '',//智能评估中项目html
            submitLoading: false,
            showProjectHtml: false,
            completenessData: '',
            completenesLoading: false,
            isProjectHtml: false,
            aiEvaStep: 0,
            aiEvaStepList: [
                { label: '项目基础评估',value: 1 },
                { label: '发起人实力评估',value: 2 },
                { label: '信息整合并生成报告', value: 3 },
                { label: '项目市州匹配', value: 4 },
                { label: '评估项目分类', value: 5 },
                { label: '评估完成', value: 6 },
            ],
            isShowStep: false,//显示评估步骤，只有在大模型评估后才显示
            evaStatus: 1,//评估状态
            autoStatusText  : '',
            evaEssessmentType: 0,//评估类型
            redo: 0,//是否是重新评估
        }
    },
    computed: {
        ...mapState({ isCollapse: (state) => state.isCollapse, }),
        ...mapGetters(['isCollapse']),
        evaStatusText() {
            this.aiEvaStepList.forEach(item => {
                if (item.value == this.evaStatus) {
                    return item.label;
                }
            })
        }
    },

    components: {
        VueMarkdown,

    },
    mounted() {
        this.ajaxsearchcompany(1);
    },
    created() {
        this.userdata = this.getuseriformation();
        this.currentTab = this.$route.query.type || '1';
        
        //currentTab匹配tabList，把对应的itemcode赋值给yj_itemcode
        let currentTabItem = this.tabList.find(item => item.value == this.currentTab);
            if (currentTabItem) {
                this.yj_itemcode = currentTabItem.itemcode;
            }
        
    },
    //监听路由变化
    watch: {
        $route: function (newVal, oldVal) {
            this.currentTab = this.$route.query.type;
        let currentTabItem = this.tabList.find(item => item.value == this.currentTab);
            if (currentTabItem) {
                this.yj_itemcode = currentTabItem.itemcode;
            }
           this.ajaxsearchcompany(1);
            
            
        }
    },
    methods: {
        //重新评估
        reAssessment(item) {
            this.redo = 1;
            this.dialogTitle = '智能评估';
            this.temdialogData = item;
            this.getAssessmentProject();
        },
        //自动评估结果下载（因为是markdown格式的，后台经过处理要做特殊下载）
        downloadReplyFile() {
            let ajaxurl = this.$api.crm.project.Download()+ "?customerId=" + this.temdialogData.id;
			var fileName = '项目文档'+ Date.now()+'.xlsx';
			try {
				//1请求后台获取文档流
				this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then((res) => {
					console.log('下载后台返回的文档流', res)
					// const blob = res;
					const blob = new Blob([res], { type: 'application/vnd.ms-excel application/x-excel' })
					//2 创建一个url 对象，并将blob实例作为参数传入，这样href的值就是以blob开头的一个文件流下载链接
					const url = window.URL.createObjectURL(blob);
					//3创建下载链接
					const a = document.createElement('a');
					a.href = url;
					a.download = fileName || Date.now();
					a.style.display = 'none';
					a.click();
					//4避免占用销毁创建的链接
					document.body.removeChild(a)

				}).catch(function (error) {
					// 请求失败处理 console.log(error);
				});
			} catch (error) {
				console.error('导出文件异常Error:', error);
			} finally {
			}
        },
        //完整性评估
        completenessFun() {
            let that = this;
            let ajaxurl = this.$api.crm.assessment.Completeness(); 
			that.completenesLoading = true;
            this.$axios.get(ajaxurl + "?customerId=" + this.temdialogData.id, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
					that.completenessData = res.data.data;
					console.log('评估结果',res.data.data);
                    that.aiEvaStep = 2;
					that.completenesLoading = false;
					// that.showProjectHtml = true;
                }else{
					that.completenesLoading = false;
                    that.$message.error(res.data.msg);
				}
            }).catch(function (error) {
                console.log(error);
                that.completenesLoading = false;
            });
            
        },
        // 简单的 Markdown 转换函数
        convertMarkdown(markdown) {
        let res =  markdown
            .replace(/^# (.*$)/gim, '<h1>$1</h1>')
            .replace(/^## (.*$)/gim, '<h2>$1</h2>')
            .replace(/^### (.*$)/gim, '<h3>$1</h3>')
            .replace(/^#### (.*$)/gim, '<h4>$1</h4>')
            .replace(/\*\*(.*)\*\*/gim, '<strong>$1</strong>')
            .replace(/\*(.*)\*/gim, '<em>$1</em>')
            .replace(/\n/gim, '<br>')
        return res;
        },
        navclick(item) {
            this.navValue = item.value;
            this.ajaxsearchcompany(1);
        },
        closeDialog(type) {
            if(type == 1){
                this.ispretentiousness = false;
                this.isInitiate = false;
            }else{
                this.showProjectHtml = false;
            }
            
        },
        handProject() {
        //判断上面的所有必填是否有数据
        if(this.temdialogData.customerName == '' || this.temdialogData.project == '' || this.temdialogData.statusText == '' || this.temdialogData.investor == '' || this.temdialogData.projectName == ''||this.temdialogData.fileList.length == 0){
            this.$message.error('请完善当前项目信息后再提交');
            return;
        }
          this.ispretentiousness = true;
        

        },
        downloadFile(url) {
            window.open(url, '_blank');
        },
        //详情页跳转
        detailrouterto(path, id) {
            if (id == 0 || id == "") {
                return;
            }
            this.routerlinkarry(path, { id: id });
        },
        //提交评估 区分人工评估还是只能评估
        submitInitiate(type) {
            if(type == 1){
                this.postEvaluation();
            }else if(type == 2){
                
                this.completenessFun();
            }else if(type == 3){
                
                this.getAssessmentProject();
            }
        },
        //人工评估
        postEvaluation(){
            let that = this;
            let ajaxurl = this.$api.crm.assessment.post();
            this.submitLoading = true;
            $.ajax({
                type: "post",
                url: ajaxurl,
                headers: {
                    AuthToken: this.userdata.token
                },
                data: { 
                    customerId: this.temdialogData.id, 
                    requirement: this.requirement 
                },
                success: function (res) {
                    if (res.success) {
                        that.$message({
                            message: '提交成功',
                            type: 'success'
                        })
                        that.isInitiate = false;
                        that.submitLoading = false;
                        that.refreeshMeunNum++;
                        that.ajaxsearchcompany(1);
                    } else {
                        that.$message.error(res.msg);
                    }
                },
            });
        },
        //发起项目人工评估弹框
        initiatePopup(item, type) {
            console.log("发起项目评估弹框", item,type);
            
            this.dialogTitle = '提交评估需求（需要完善以下项目信息才能提交评估）';
            if(type == 'initiate'){
                this.dialogTitle = '提交评估需求（需要完善以下项目信息才能提交评估）';
                this.isInitiate = true;
                this.temdialogData = item;
                this.evaluationType = 1;
            }else if(type == 'completeness'){
                 this.dialogTitle = '智能评估';
                this.temdialogData = item;
                if(item.assessmentType == 2){//如果已经进行过大模型评估，那么访问评估结果接口，完成就显示结果，没完成就显示当前步骤
                    console.log('已经进行过大模型评估',item.assessmentTypeText);
                    this.getEvaluationResults(this.temdialogData.id);
                }else{
                    this.showProjectHtml = true;
                    this.aiEvaStep = 1;
                }
                
            }else{
                this.evaEssessmentType = item.assessmentType;
                this.dialogTitle = '评估结果';
                this.isInitiate = true;
                if(item.assessmentType != 1){ //1为人工评估 2为智能评估
                    this.getEvaluationResults(item.id);
                }else{
                    this.resultsPopup(item);
                }
                
                
            }
        },
        //智能评估
        getAssessmentProject(){
            let that = this;
            let jaredo = this.redo ? '&redo=1' : '';
            let ajaxurl = this.$api.crm.assessment.Project()+"?customerId="+this.temdialogData.id+jaredo;
            if(this.temdialogData.fileList.length == 0){
                this.$message.error('请前往项目详情上传项目文件');
                return;
            }
            this.submitLoading = true;
            this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    console.log('智能评估',res);
                    if(jaredo == ''){
                        that.isInitiate = false;
                        that.showProjectHtml = true;
                        that.assessmentProjectHtml = res.data.data;
                        that.aiEvaStep = 3;
                    }
                    
                    
                    that.$message({ 
                        message: '提交成功',
                        type: 'success'
                    })
                    
                    // this.$notify({
                    //     title: '提示',
                    //     message: '您已提交"<strong class="basefont font-16">'+ that.temdialogData.project + '</strong>"项目评估需求，评估预计需要5-10分钟，请稍后再来查看评估结果',
                    //     duration: 0,
                    //     dangerouslyUseHTMLString: true,
                    //      type: 'success'
                    // });

                }else{
                    that.$message.error(res.data.msg);
                }
                that.submitLoading = false;
            })
        },
        // 获取项目大模型评估结果
        getEvaluationResults(id) {
            let that = this;
            let ajaxurl = this.$api.crm.assessment.ProjectDetail()+"?customerId="+id;
            this.$axios.get(ajaxurl, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
                if (res.data.success) {
                    that.isShowStep = true;
                    console.log('智能评估结果',res);
                    // if(res.data.data.status == 6){
                        that.aiEvaStep = 3;
                        // that.showProjectHtml = true;
                        that.assessmentProjectHtml = res.data.data;
                        that.evaStatus = res.data.data.status;
                        that.temdialogData = res.data.data;
                        that.autoStatusText = res.data.data.statusText;
                        console.log('智能评估结果',res.data.data,that.autoStatusText);
                    // }else{
                        that.aiEvaStep = res.data.data.status;
                    // }
                 
                    
                }

            })
        },
        resultsPopup(item) {
            let that = this;
            let ajaxurl = this.$api.crm.assessment.detail();
            $.ajax({
                type: "get",
                url: ajaxurl,
                headers: {
                    AuthToken: this.userdata.token
                },
                data: { 
                    customerId: item.id
                 },
                success: function (res) {
                    console.log("项目详情", res);
                    if (res.success) {
                        that.temdialogData = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                },
            });
        },
        // 标签切换
        tabClick(item) {
            this.currentTab = item.value;
            this.ajaxsearchcompany(1);
        },
        ajaxsearchcompany(page) {
            this.page = page || 1;
            // 获取企业列表
            // 获取项目列表
            this.bus.$emit('loading', true);
            var _this = this;
            let ajaxurl1 = this.$api.crm.project.list() + '?page=' + this.page + '&pageSize=' + this.pageSize + '&menu=' + this.currentTab+'&projectType='+this.navValue;
            this.$axios.get(ajaxurl1, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {

                console.log("项目列表", res.data);
                if (res.data.success) {
                    _this.enterpristlist = res.data.list;
                    _this.pageSize = res.data.pageSize//每一页显示的数据条数
                    _this.total = res.data.totalRecord//每一页显示的数据条数
                    _this.totalPage = res.data.totalPage//每一页显示的数据条数
                    if(_this.currentTab == 17){
                        for(var i=0;i<_this.enterpristlist.length;i++){
                            if(_this.enterpristlist[i].assessmentType != 1)
                            _this.getEvaluationResults(_this.enterpristlist[i].id);
                        }
                        
                    }    

                } else {
                    _this.$message.error(res.data.msg);
                }
                _this.bus.$emit('loading', false);
            }).catch(function (err) {
                console.log(err);
            });
        },
        pageHandler: function (page) {
            this.ajaxsearchcompany(page, 'sort', 'search');
        },
    }
}
</script>

<style scoped lang="scss">
@import url('../../css/yuanbao/yuanbao1.css');
.report-container {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
.enterprise_list_box {
    min-height: 75vh;
}
.cur-pointer.bluefont {
    &:hover {
        color: #ff7f07;
    }
}

.initiate_box {
    font-size: 16px;
}

.initiate_title {
    font-weight: 600;
}

.initiate_box_dialog {
    border-radius: 10px;
}
</style>